module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraBold.ad52a15.woff2";